module.exports = __webpack_public_path__ + "static/media/zealix-1.6c4a2870.jpg";